/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cn_Android_Paywall_Benefit_Foot_NoteInputs */

const en_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don’t Worry. No auto-renewal.`)
};

const ar_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don’t Worry. No auto-renewal.`)
};

const de_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don’t Worry. No auto-renewal.`)
};

const es_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don’t Worry. No auto-renewal.`)
};

const fr_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don’t Worry. No auto-renewal.`)
};

const it_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don’t Worry. No auto-renewal.`)
};

const ja_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don’t Worry. No auto-renewal.`)
};

const ko_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don’t Worry. No auto-renewal.`)
};

const pt_br_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don’t Worry. No auto-renewal.`)
};

const ru_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don’t Worry. No auto-renewal.`)
};

const th_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don’t Worry. No auto-renewal.`)
};

const tr_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don’t Worry. No auto-renewal.`)
};

const zh_cn_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放心续费，无自动扣费
Plus 会员时长自己掌控`)
};

const zh_tw_cn_android_paywall_benefit_foot_note = /** @type {(inputs: Cn_Android_Paywall_Benefit_Foot_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放心续费，无自动扣费
Plus 会员时长自己掌控`)
};

/**
* | output |
* | --- |
* | "Don’t Worry. No auto-renewal." |
*
* @param {Cn_Android_Paywall_Benefit_Foot_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const cn_android_paywall_benefit_foot_note = /** @type {((inputs?: Cn_Android_Paywall_Benefit_Foot_NoteInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cn_Android_Paywall_Benefit_Foot_NoteInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cn_android_paywall_benefit_foot_note(inputs)
	if (locale === "ar") return ar_cn_android_paywall_benefit_foot_note(inputs)
	if (locale === "de") return de_cn_android_paywall_benefit_foot_note(inputs)
	if (locale === "es") return es_cn_android_paywall_benefit_foot_note(inputs)
	if (locale === "fr") return fr_cn_android_paywall_benefit_foot_note(inputs)
	if (locale === "it") return it_cn_android_paywall_benefit_foot_note(inputs)
	if (locale === "ja") return ja_cn_android_paywall_benefit_foot_note(inputs)
	if (locale === "ko") return ko_cn_android_paywall_benefit_foot_note(inputs)
	if (locale === "pt_br") return pt_br_cn_android_paywall_benefit_foot_note(inputs)
	if (locale === "ru") return ru_cn_android_paywall_benefit_foot_note(inputs)
	if (locale === "th") return th_cn_android_paywall_benefit_foot_note(inputs)
	if (locale === "tr") return tr_cn_android_paywall_benefit_foot_note(inputs)
	if (locale === "zh_cn") return zh_cn_cn_android_paywall_benefit_foot_note(inputs)
	return zh_tw_cn_android_paywall_benefit_foot_note(inputs)
});